module.exports = __webpack_public_path__ + "img/Préparion plancher en bois composite pour terrasse métallique.620302d0.jpg";